import { useParams } from "react-router-dom";
import ProcedureTemplate from "../templates/ProcedureTemplate";
import { SAMPLE_PROCEDURE, PROCEDURE_ROUTES } from "../data/procedures";

// Build honest placeholder data for procedure routes not yet fully written.
function findTitle(slug) {
  for (const list of Object.values(PROCEDURE_ROUTES)) {
    const hit = list.find((p) => p.slug === slug);
    if (hit) return hit.title;
  }
  return slug.replace(/-vietnam$/, "").replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

function placeholderProcedure(slug) {
  const name = findTitle(slug);
  return {
    slug,
    h1: `${name} in Vietnam`,
    summary: `${name} is one of the procedures international patients ask about. Detailed, medically-reviewed content for this page is being prepared. Suitability, techniques and outcomes can only be confirmed by a licensed surgeon after an in-person examination.`,
    involves: "Full details for this procedure are being finalised by our team. In the meantime, you can request a private case review to receive guidance specific to your situation.",
    suitable: ["Adults in good general health", "Those with realistic, clearly discussed expectations", "People able to follow pre- and post-operative guidance"],
    notSuitable: ["Patients with uncontrolled medical conditions until reviewed", "Those seeking guaranteed or idealised results"],
    techniques: ["Techniques confirmed after assessment"],
    questions: [
      "Are you licensed to perform this procedure, and where can I verify this?",
      "In which licensed facility will surgery take place?",
      "What are the realistic limitations in my case?",
      "What happens if a complication or revision is needed?",
    ],
    risks: "As with any surgery, risks may include bleeding, infection, scarring and the possibility of revision. Individual risk depends on your health, anatomy, technique and aftercare.",
    outcome: "Results vary between patients and develop over time. No result is guaranteed.",
    preparation: "Medical tests and lifestyle guidance may be advised before surgery.",
    anaesthesia: "Confirmed by the medical team based on the procedure.",
    duration: "Depends on complexity — confirmed at consultation.",
    hospitalStay: "Depends on the procedure and surgeon's guidance.",
    recovery: "A recovery timeline is provided by the treating surgeon.",
    stayInVietnam: "The required stay depends on the operation, follow-up and your surgeon's travel-clearance advice.",
    flyingHome: "Flying should only take place once cleared by the treating surgeon.",
    costFactors: ["Surgeon and facility", "Anaesthesia", "Tests and follow-up care", "Primary versus revision surgery"],
    isPlaceholder: true,
  };
}

const RELATED = [
  { to: "/nose-surgery-vietnam", title: "Nose surgery in Vietnam" },
  { to: "/procedures", title: "All procedures" },
  { to: "/plastic-surgery-safety-vietnam", title: "Is plastic surgery in Vietnam safe?" },
  { to: "/how-to-choose-a-plastic-surgeon-in-vietnam", title: "How to choose a surgeon" },
  { to: "/plastic-surgery-cost-vietnam", title: "Plastic surgery costs in Vietnam" },
  { to: "/patient-journey", title: "The patient journey" },
  { to: "/international-patient-aftercare-vietnam", title: "Recovery & aftercare support" },
];

export default function ProcedurePage() {
  const { slug } = useParams();
  const data = slug === SAMPLE_PROCEDURE.slug ? SAMPLE_PROCEDURE : placeholderProcedure(slug);
  return <ProcedureTemplate data={data} related={RELATED} />;
}
